export default __webpack_public_path__ + "static/blob7-722b67f96fe674664697fc8806d14d09.svg";